export default __webpack_public_path__ + "static/media/shooting.7fc9f390.PNG";